<div class="col-xl">
    <form [formGroup]="providerForm" (ngSubmit)="onSubmit()">
        <div class="card mb-4">
            <div class="card-body">

                <h5 class="section-title mb-3 d-flex align-items-center gap-2">
                    <img src="assets/img/provider/icon-user-square.svg" alt="" width="18" height="18">
                    Información general
                </h5>
                <div class="row g-3 mb-4">
                    <div class="col-md-4">
                        <label class="form-label">Razón social</label>
                        <input type="text" class="form-control" placeholder="Ingresar" formControlName="business_name"
                            [class.is-invalid]="fc['business_name'].errors && isSubmitted">
                        <div class="invalid-feedback" *ngIf="fc['business_name'].errors && isSubmitted">
                            El campo razón social es obligatorio
                        </div>
                    </div>
                    <div class="col-md-4">
                        <label class="form-label">Nombre comercial</label>
                        <input type="text" class="form-control" placeholder="Ingresar" formControlName="trade_name">
                    </div>
                    <div class="col-md-4">
                        <label class="form-label">Tipo de proveedor</label>
                        <select class="form-select" formControlName="provider_type">
                            <option value="">Seleccionar</option>
                            <option *ngFor="let t of providerTypes" [value]="t">{{t}}</option>
                        </select>
                    </div>
                    <div class="col-md-4">
                        <label class="form-label">RFC</label>
                        <input type="text" class="form-control" placeholder="Ingresar" formControlName="rfc"
                            [class.is-invalid]="fc['rfc'].errors && isSubmitted">
                        <div class="invalid-feedback" *ngIf="fc['rfc'].errors && isSubmitted">
                            El campo RFC es obligatorio
                        </div>
                    </div>
                    <div class="col-md-4">
                        <label class="form-label">Correo electrónico</label>
                        <input type="email" class="form-control" placeholder="Ingresar" formControlName="email">
                    </div>
                    <div class="col-md-4">
                        <label class="form-label">Teléfono</label>
                        <input type="text" class="form-control" placeholder="Ingresar" formControlName="phone">
                    </div>
                    <div class="col-md-12">
                        <label class="form-label">Dirección fiscal</label>
                        <input type="text" class="form-control" placeholder="Ingresar" formControlName="fiscal_address"
                            autocomplete="fiscal-address-no-autofill" name="fiscal_address_no_autofill"
                            [appGooglePlaces]="fc['fiscal_address']">
                    </div>
                </div>

                <h5 class="section-title mb-3 d-flex align-items-center gap-2">
                    <img src="assets/img/provider/icon-bank.svg" alt="" width="18" height="18">
                    Información bancaria
                </h5>
                <div class="row g-3">
                    <div class="col-md-4">
                        <label class="form-label">Banco</label>
                        <select class="form-select" formControlName="bank_name">
                            <option value="">Seleccionar</option>
                            <option *ngFor="let b of banks" [value]="b.name">{{ b.name }}</option>
                        </select>
                    </div>
                    <div class="col-md-4">
                        <label class="form-label">Nombre del beneficiario</label>
                        <input type="text" class="form-control" placeholder="Ingresar" formControlName="beneficiary_name">
                    </div>
                    <div class="col-md-4">
                        <label class="form-label">Tipo de cuenta</label>
                        <select class="form-select" formControlName="account_type">
                            <option value="">Seleccionar</option>
                            <option *ngFor="let t of accountTypes" [value]="t">{{t}}</option>
                        </select>
                    </div>
                    <div class="col-md-4">
                        <label class="form-label">Cuenta</label>
                        <input type="text" class="form-control" placeholder="Ingresar" formControlName="account_number">
                    </div>
                    <div class="col-md-4">
                        <label class="form-label">CLABE</label>
                        <input type="text" class="form-control" placeholder="Ingresar" formControlName="clabe">
                    </div>
                </div>

                <div>
                    <div class="d-flex justify-content-between align-items-center mb-3 mt-4">
                        <h5 class="section-title mb-0 d-flex align-items-center gap-2">
                            <img src="assets/img/provider/icon-money.svg" alt="" width="18" height="18">
                            Pagos a realizar a este proveedor
                        </h5>
                        <button type="button" class="btn btn-outline-info" (click)="addPaymentRow()">
                            + Agregar otro concepto
                        </button>
                    </div>

                    <div formArrayName="payments">
                        <div *ngFor="let row of payments.controls; let i = index" [formGroupName]="i" class="concept-block mb-4 pb-3">
                            <div class="d-flex justify-content-between align-items-center mb-2">
                                <h6 class="concept-title mb-0">Concepto #{{ i + 1 }}</h6>
                                <button type="button" class="btn btn-link p-0 concept-delete-btn" *ngIf="payments.length > 1"
                                    (click)="removePaymentRow(i)" title="Quitar concepto" aria-label="Quitar concepto">
                                    <i class="ti ti-trash"></i>
                                </button>
                            </div>
                            <div class="row g-3">
                                <div class="col-md-6">
                                    <label class="form-label">Concepto de pago</label>
                                    <input type="text" class="form-control" placeholder="Ingresar" formControlName="concept"
                                        [class.is-invalid]="row.get('concept')?.errors && isSubmitted">
                                </div>
                                <div class="col-md-3">
                                    <label class="form-label">Recurrencia del pago</label>
                                    <select class="form-select" formControlName="recurrence"
                                        [class.is-invalid]="row.get('recurrence')?.errors && isSubmitted">
                                        <option value="">Seleccionar</option>
                                        <option *ngFor="let r of recurrenceOptions" [value]="r">{{r}}</option>
                                    </select>
                                </div>
                                <div class="col-md-3" *ngIf="isMonthlyFamily(row.get('recurrence')?.value)">
                                    <label class="form-label">Fecha límite de pago</label>
                                    <div class="day-picker">
                                        <button type="button" class="form-control day-picker-trigger" (click)="toggleDayPicker(i)">
                                            <i class="ti ti-calendar"></i>
                                            <span>{{ row.get('due_day')?.value || 'Seleccionar' }}</span>
                                            <i class="ti ti-chevron-down day-picker-chevron" [class.rotated]="openDayPickerIndex === i"></i>
                                        </button>
                                        <div class="day-picker-dropdown" *ngIf="openDayPickerIndex === i">
                                            <div class="day-picker-grid">
                                                <button type="button" *ngFor="let d of dayGridOptions" class="day-picker-cell"
                                                    [class.active]="row.get('due_day')?.value === d"
                                                    (click)="selectDay(i, d)">{{ d }}</button>
                                            </div>
                                            <button type="button" class="day-picker-last-day"
                                                [class.active]="row.get('due_day')?.value === 'Último día del mes'"
                                                (click)="selectDay(i, 'Último día del mes')">Último día del mes</button>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-3" *ngIf="!isMonthlyFamily(row.get('recurrence')?.value)">
                                    <label class="form-label">Fecha límite de pago</label>
                                    <input type="date" class="form-control" formControlName="start_date">
                                </div>
                                <div class="col-md-4">
                                    <label class="form-label">Monto a pagar</label>
                                    <input type="text" inputmode="decimal" class="form-control" placeholder="Ingresar" formControlName="amount" appThousandsFormat>
                                </div>
                                <div class="col-md-8 d-flex align-items-center gap-2 pb-2">
                                    <input type="checkbox" class="form-check-input mt-0" id="priority{{i}}" formControlName="priority">
                                    <label class="form-check-label" for="priority{{i}}">Pago con prioridad</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>

        <div class="d-flex justify-content-end mb-4">
            <button type="submit" class="btn btn-info">
                {{ isEdit ? 'Guardar cambios' : '+ Agregar proveedor' }}
            </button>
        </div>
    </form>
</div>

<ngx-spinner bdColor="rgba(0, 0, 0, 0.7)" size="medium" color="#fff" type="ball-atom">
    <div class="loader"></div>
    <p style="font-size: 20px; color: white">Espere un momento...</p>
</ngx-spinner>
